<template>
    <div class="modal fade" id="viewIdCardPrintModal">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header bg-aqua">
                <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Employee ID Card</h4>
                </div>
                <div class="modal-body" id="printIdCardPrintModal">
                    <div class="card card-primary card-outline padding-sm" style="border-style: solid; padding: 6px 6px 6px 6px;">
                        <div class="row">
                            <div class="col-md-12 col-sm-12 text-center">
                                <img
                                class="profile-user-img img-fluid"
                                :src= this.logo
                                alt="company logo"
                                style="width:65px; height: 52px"
                            />
                            <br>
                            <!-- </div>
                            <div class="col-md-9 col-sm-9"> -->
                                <div v-if="getCompanyRecord.companyName">
                                <p class="text-center" style="font-family: Copperplate, Fantasy;">{{ getCompanyRecord.companyName.toUpperCase() }}</p>
                                </div>
                            </div>
                        </div>
                        <div v-if="empInfo.user" class="card-body box-profile">
                            <div class="text-center">
                            <img
                                class="profile-user-img img-fluid img-circle"
                                :src= this.photo
                                alt="User profile picture"
                                style="height: 112px"
                            />
                            </div>
                            <p class="text-center text-bold">
                            {{ empInfo.user.name.toUpperCase() }}
                            </p>

                            <p class="text-muted text-center">
                           ( {{ empInfo.designation.name.toUpperCase() }} )
                           </p>

                                <b>Employee Code</b>
                                <a class="pull-right">{{ empInfo.user.code }}</a><br>
                            <!-- <li class="list-group-item">
                                <b>Branch</b>
                                <a class="pull-right">{{ empInfo.branch.name }}</a>
                            </li> -->
                                <b>Phone Number</b>
                                <a class="pull-right">{{ empInfo.user.mobile }}</a><br>
                                <b>City</b>
                                <a class="pull-right">{{ empInfo.city }}</a><br>
                                <!-- <b>DOB</b>
                                <a class="pull-right">{{ empInfo.dob }}</a><br>
                                <b>Joining Date</b>
                                <a class="pull-right">{{ empInfo.joiningDate }}</a><br> -->
                        </div>
                        <!-- /.card-body -->
                    </div>
                </div>
                <div class="modal-footer text-center">
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="printIdCardPrintModal"
                >
                    PRINT
                </button>
                <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                >
                    CLOSE
                </button>
                </div>
            </div>
        <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
</template>
<script>
export default({
  name: 'EmployeeIDCard',
  methods: {
    printIdCardPrintModal () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('printIdCardPrintModal').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@3.4.1/dist/css/bootstrap.min.css" integrity="sha384-HSMxcRTRxnN+Bdg0JdbxYKrThecOKuH5zCYotlSAcp1+c8xmyTe9GYg1l9a69psu" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
              <style>
              @page {
                    size: 3.5in 4.6in;
                    }
                @media print {
                     .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6,
                    .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {
                        float: left;               
                    }

                    .col-sm-12 {
                        width: 100%;
                    }

                    .col-sm-11 {
                        width: 91.66666666666666%;
                    }

                    .col-sm-10 {
                        width: 83.33333333333334%;
                    }

                    .col-sm-9 {
                            width: 75%;
                    }

                    .col-sm-8 {
                            width: 66.66666666666666%;
                    }

                    .col-sm-7 {
                            width: 58.333333333333336%;
                    }

                    .col-sm-6 {
                            width: 50%;
                    }

                    .col-sm-5 {
                            width: 41.66666666666667%;
                    }

                    .col-sm-4 {
                            width: 33.33333333333333%;
                    }

                    .col-sm-3 {
                            width: 25%;
                    }

                    .col-sm-2 {
                            width: 16.666666666666664%;
                    }

                    .col-sm-1 {
                            width: 8.333333333333332%;
                        }        
                    .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6,
                    .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12 {
                        float: left;               
                    }

                    .col-md-12 {
                        width: 100%;
                    }

                    .col-md-11 {
                        width: 91.66666666666666%;
                    }

                    .col-md-10 {
                        width: 83.33333333333334%;
                    }

                    .col-md-9 {
                            width: 75%;
                    }

                    .col-md-8 {
                            width: 66.66666666666666%;
                    }

                    .col-md-7 {
                            width: 58.333333333333336%;
                    }

                    .col-md-6 {
                            width: 50%;
                    }

                    .col-md-5 {
                            width: 41.66666666666667%;
                    }

                    .col-md-4 {
                            width: 33.33333333333333%;
                    }

                    .col-md-3 {
                            width: 25%;
                    }

                    .col-md-2 {
                            width: 16.666666666666664%;
                    }

                    .col-md-1 {
                            width: 8.333333333333332%;
                        }      
                }
              </style>
          </head>
          <body>
              ${prtHtml}              
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }
  },
  props: {
    empInfo: {},
    photo: '',
    logo: '',
    getCompanyRecord: {}
  }
})
</script>



// WEBPACK FOOTER //
// EmployeeIdCard.vue?2c141aa6